<template>
    <div class="tile" @click="openAlbum">
        <intrinsic :small="src" :alt="alt" ratio="12x8" :fit="true"></intrinsic>
        <div class="tile__description">
            {{ description }}
        </div>
    </div>
</template>

<script>
    import Intrinsic from "../shared/intrinsic.vue";
	export default {
		name: "tile",
		components: {
			Intrinsic
		},
		props: [
			"src",
			"alt",
			"description"
		],
		methods: {
			openAlbum () {
				this.albumParent.openModal(this.src);
			},
		},
		computed: {
			albumParent () {
				let current = this.$parent;
				while (current.$options._componentTag !== "album") {
					current = current.$parent;
				}
				return current;
			}
		}
	};
</script>

<style lang="scss" scoped>
    .tile {
        width: 100%;
        flex: auto;
        flex-wrap: wrap;
        position: relative;
        overflow: hidden;
        margin: 1px;
        cursor: pointer;
        &:hover {
            .tile__description {
                transform: translateY(-2rem);
            }
        }
        &__description {
            width: 100%;
            position: absolute;
            bottom: -2rem;
            left: 0;
            padding: .5rem;
            color: white;
            background: rgba(0,0,0,.4);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            height: 2rem;
            transition: all 275ms;
            font-size: 1rem;
            line-height: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// tile.vue?c102ec6c